import type { ReactNode } from 'react';
import { cn } from '../_lib/utils';
import { ComponentButton, type ComponentButtonProps } from '../Inputs/Button';
import { Text } from '../Text';
import { LabelLink, type LabelLinkProps } from '../LabelLink';

export type CardSectionHeaderProps = {
	className?: string;
	overline?: string;
	label?: Pick<LabelLinkProps, 'copy' | 'href' | 'icon'>;
	title: ReactNode;
	button?: ComponentButtonProps;
};

export function CardSectionHeader(props: CardSectionHeaderProps) {
	return (
		<div
			className={cn('flex flex-col items-start gap-responsive-sm sm:flex-row sm:items-end', props.className)}
			data-component='CardSectionHeader'
		>
			<div className={`flex flex-col gap-responsive-2xs`}>
				{props.overline && (
					<Text as='span' className={`text-text-brand`} styleType='label-sm'>
						{props.overline}
					</Text>
				)}
				{props.label && <LabelLink {...props.label} size='md' styleType='brand' />}
				<Text as='h2' styleType='heading-md'>
					{props.title}
				</Text>
			</div>
			{props.button && <ComponentButton className={`sm:ml-auto`} {...props.button} />}
		</div>
	);
}
